import { useStore } from 'effector-react'

import {
  $cashBooster,
  $totalCountOfCashBooster,
  cashBoosterMounted,
  getCashBooster,
} from './model'
import { CashBoosterRequest } from './types'

export const useCashBoosterList = () => {
  const onChangeCashBoosterList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: CashBoosterRequest) => {
    cashBoosterMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  const loading = useStore(getCashBooster.pending)

  const cashBooster = useStore($cashBooster)
  const totalCountOfCashBooster = useStore($totalCountOfCashBooster)

  return {
    cashBooster,
    totalCountOfCashBooster,
    loading,
    onChangeCashBoosterList,
  }
}
